<template>
  <div class="dflex mt-3">
    <div class="col row">
      <label class="vform-editor-label section mt-0">{{ $t('vform.TextAlignment') }}</label>
    </div>
    <set-by-template v-if="selectedTemplate.textAlignment" />
    <div
        v-else
        v-for="(align, index) in alignments"
        :key="'textAlign' + index"
        :class="['vform-alignment-button', align === element.textAlignment ? 'active' : '',]"
        @click="setTextAlignment(align)"
    >
      <icon :type="'align-' + align" size="1"/>
      <div class="icon" v-if="align === 'auto'">A</div>
    </div>
  </div>
</template>

<script>
import SetByTemplate from "@/components/vForm/SetByTemplate.vue";
import Icon from "@/components/Icon.vue";

export default {
  name: "AlignmentEditor",
  components: {Icon, SetByTemplate},
  props: {
    element: { type: Object, required: true },
    selectedTemplate: { type: Object, required: true },
  },
  data() {
    return {
      alignments: ["left", "center", "right", "justify", "auto"],
    }
  },
  methods: {
    setTextAlignment(align) {
      this.$set(this.element, 'textAlignment', align);
    },
  }
}
</script>

<style scoped lang="scss">

</style>